var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextjs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#151521"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 15.2L15.848 14.7312C15.7489 14.5943 15.6089 14.4923 15.4483 14.4398C15.2876 14.3874 15.1144 14.3872 14.9536 14.4392C14.7928 14.4913 14.6526 14.593 14.5531 14.7296C14.4537 14.8663 14.4001 15.031 14.4 15.2H15.2ZM20 30.4C17.2417 30.4 14.5965 29.3043 12.6461 27.3539C10.6957 25.4035 9.6 22.7583 9.6 20H8C8 23.1826 9.26428 26.2348 11.5147 28.4853C13.7652 30.7357 16.8174 32 20 32V30.4ZM30.4 20C30.4 21.3657 30.131 22.7181 29.6083 23.9799C29.0857 25.2417 28.3196 26.3882 27.3539 27.3539C26.3882 28.3196 25.2417 29.0857 23.9799 29.6083C22.7181 30.131 21.3657 30.4 20 30.4V32C23.1826 32 26.2348 30.7357 28.4853 28.4853C30.7357 26.2348 32 23.1826 32 20H30.4ZM20 9.6C21.3657 9.6 22.7181 9.869 23.9799 10.3917C25.2417 10.9143 26.3882 11.6804 27.3539 12.6461C28.3196 13.6118 29.0857 14.7583 29.6083 16.0201C30.131 17.2819 30.4 18.6343 30.4 20H32C32 16.8174 30.7357 13.7652 28.4853 11.5147C26.2348 9.26428 23.1826 8 20 8V9.6ZM20 8C16.8174 8 13.7652 9.26428 11.5147 11.5147C9.26428 13.7652 8 16.8174 8 20H9.6C9.6 17.2417 10.6957 14.5965 12.6461 12.6461C14.5965 10.6957 17.2417 9.6 20 9.6V8ZM16 27.2V15.2H14.4V27.2H16ZM14.552 15.6688L24.952 30.0688L26.248 29.1312L15.848 14.7312L14.552 15.6688ZM24 14.4V24H25.6V14.4H24Z",
    fill: "#151521"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextjs);
export default __webpack_public_path__ + "static/media/nextjs.4da9eb1670a49597b461c5474e4fa5bf.svg";
export { ForwardRef as ReactComponent };